import api from './api'

export const partnerService = {
  // ── Admin — iş ortağı şirketleri ──────────────────────────────────
  list: async (params = {}) => (await api.get('/admin/partners', { params })).data,
  pageGroup: async () => (await api.get('/admin/partners/page-group')).data,
  get: async (id) => (await api.get(`/admin/partners/${id}`)).data,
  create: async (payload) => (await api.post('/admin/partners', payload)).data,
  update: async (id, payload) => (await api.put(`/admin/partners/${id}`, payload)).data,
  getPermissions: async (id) => (await api.get(`/admin/partners/${id}/permissions`)).data,
  savePermissions: async (id, permissions) =>
    (await api.put(`/admin/partners/${id}/permissions`, { permissions })).data,
  addUser: async (id, payload) => (await api.post(`/admin/partners/${id}/users`, payload)).data,
  removeUser: async (id, userId) => (await api.delete(`/admin/partners/${id}/users/${userId}`)).data,
  deleteAccount: async (userId) => (await api.delete(`/admin/partners/accounts/${userId}`)).data,
  updateUser: async (id, userId, flags) => (await api.put(`/admin/partners/${id}/users/${userId}`, flags)).data,

  // ── Admin — iskonto kuralları ─────────────────────────────────────
  discounts: async (id) => (await api.get(`/admin/partners/${id}/discounts`)).data,
  saveDiscount: async (id, payload) =>
    (await api.put(`/admin/partners/${id}/discounts`, payload)).data,
  // Süzgece uyan TÜM ürünlere ürün kuralı (sunucu kodları kendisi çözer)
  applyDiscountFiltered: async (id, payload) =>
    (await api.put(`/admin/partners/${id}/discounts/apply-filtered`, payload, { timeout: 180000 })).data,
  saveDiscountsBulk: async (id, payload) =>
    (await api.put(`/admin/partners/${id}/discounts/bulk`, payload)).data,
  deleteDiscount: async (id, ruleId) =>
    (await api.delete(`/admin/partners/${id}/discounts/${ruleId}`)).data,
  setCatalogVisibility: async (id, payload) =>
    (await api.post(`/admin/partners/${id}/catalog-visibility`, payload)).data,
  deleteMaterialDiscounts: async (id, payload) =>
    (await api.post(`/admin/partners/${id}/discounts/delete-materials`, payload)).data,
  deleteDiscountsBulk: async (id, ids) =>
    (await api.post(`/admin/partners/${id}/discounts/bulk-delete`, { ids })).data,
  discountOptions: async (id) =>
    (await api.get(`/admin/partners/${id}/discounts/options`)).data,
  discountCatalog: async (id, params = {}) =>
    (await api.get(`/admin/partners/${id}/discounts/catalog`, { params })).data,
  // Kural setinin BİR ürüne ne uyguladığını gösterir (hangi kapsam kazandı)
  discountPreview: async (id, material) =>
    (await api.get(`/admin/partners/${id}/discounts/preview`, { params: { material } })).data,

  // ── Admin — sevkiyat / kargo ──────────────────────────────────────
  shipments: async (id) => (await api.get(`/admin/partners/${id}/shipments`)).data,
  saveShipment: async (id, payload) =>
    (await api.put(`/admin/partners/${id}/shipments`, payload)).data,
  deleteShipment: async (id, shipId) =>
    (await api.delete(`/admin/partners/${id}/shipments/${shipId}`)).data,

  // ── İç ekran — partner sipariş talepleri ──────────────────────────
  orders: async (params = {}) => (await api.get('/partner-orders', { params })).data,
  order: async (orderId) => (await api.get(`/partner-orders/${orderId}`)).data,
  decideOrder: async (orderId, approve, note) =>
    (await api.post(`/partner-orders/${orderId}/decide`, { approve, note })).data,
  // Onaylı ama teklifi açılmamış talep için teklifi tekrar dener
  retryQuote: async (orderId) =>
    (await api.post(`/partner-orders/${orderId}/create-quote`, {}, { timeout: 75000 })).data,

  // ── Partner paneli ────────────────────────────────────────────────
  me: async () => (await api.get('/partner/me')).data,
  catalog: async (params = {}) => (await api.get('/partner/catalog', { params })).data,
  // Katalog hunisi değer listesi / divizyon-aile seçenekleri / sağ panel ürün kartı
  catalogFacets: async (params = {}) => (await api.get('/partner/catalog/facets', { params })).data,
  catalogDivisions: async () => (await api.get('/partner/catalog/divisions')).data,
  catalogFamilies: async (parent) =>
    (await api.get('/partner/catalog/families', { params: parent ? { parent_anagrup: parent } : {} })).data,
  catalogProduct: async (material) =>
    (await api.get('/partner/catalog/product', { params: { material } })).data,
  // Belgeler — sipariş / irsaliye / fatura (tüm süreç)
  myDocuments: async (kind, params = {}) =>
    (await api.get('/partner/documents', { params: { kind, ...params } })).data,
  // Belgelerim ürün araması — kalemlerinde ürün kodu / adı geçen belgeler
  myDocumentsByProduct: async (kind, q, signal) =>
    (await api.get('/partner/documents/product-search', { params: { kind, q }, signal })).data,
  // Bizim bu iş ortağından aldığımız malın faturası / irsaliyesi — başlık + kalemler
  purchaseDocument: async (kind, docnum) =>
    (await api.get(`/partner/purchase-documents/${encodeURIComponent(docnum)}`, { params: { kind } })).data,

  myStock: async (search) =>
    (await api.get('/partner/stock', { params: search ? { search } : {} })).data,
  // Önizleme — dosyayı çözümler, YAZMAZ
  // Stok satırı + (katalogdaysa) ürün kartı — kod sorguda ('/' geçebilir)
  stockItem: async (material) =>
    (await api.get('/partner/stock/item', { params: { material } })).data,
  // Tek satır ekle/düzenle — kod gövdede
  saveStockItem: async (payload) =>
    (await api.put('/partner/stock/item', payload)).data,
  deleteStock: async (codes) =>
    (await api.post('/partner/stock/delete', { codes })).data,

  previewStock: async (file) => {
    const fd = new FormData()
    fd.append('file', file)
    return (await api.post('/partner/stock/preview', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    })).data
  },
  uploadStock: async (file) => {
    const fd = new FormData()
    fd.append('file', file)
    return (await api.post('/partner/stock/upload', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    })).data
  },

  cart: async () => (await api.get('/partner/cart')).data,
  // Sepet formu seçenekleri — cariden ödeme koşulu + ilgili kişiler
  orderMeta: async () => (await api.get('/partner/order-meta')).data,
  addToCart: async (material_code, qty = 1, note) =>
    (await api.post('/partner/cart/items', { material_code, qty, note })).data,
  updateCartItem: async (itemId, payload) =>
    (await api.put(`/partner/cart/items/${itemId}`, payload)).data,
  removeCartItem: async (itemId) => (await api.delete(`/partner/cart/items/${itemId}`)).data,
  clearCart: async () => (await api.delete('/partner/cart')).data,
  refreshCart: async () => (await api.post('/partner/cart/refresh')).data,
  // Toplu ekleme — AI ile liste çözümleme (yalnız mevcut katalogdan)
  bulkPreview: async (payload) =>
    (await api.post('/partner/cart/bulk-preview', payload, { timeout: 120000 })).data,
  bulkAdd: async (lines) =>
    (await api.post('/partner/cart/bulk-add', { lines }, { timeout: 120000 })).data,
  // Sepet başlığı (not/referans/şartlar) — kalıcı
  updateCart: async (payload) => (await api.patch('/partner/cart', payload)).data,
  submitCart: async (payload = {}) => (await api.post('/partner/cart/submit', payload)).data,

  myOrders: async (params = {}) => (await api.get('/partner/orders', { params })).data,
  // Sipariş takibi — talepler + canias siparişleri; partnerin kendi no'su + bizim no'muz
  orderTracking: async () => (await api.get('/partner/order-tracking')).data,
  setOrderLabel: async (payload) => (await api.put('/partner/order-tracking/label', payload)).data,
  myOrder: async (orderId) => (await api.get(`/partner/orders/${orderId}`)).data,
  cancelOrder: async (orderId) => (await api.post(`/partner/orders/${orderId}/cancel`)).data,

  myShipments: async () => (await api.get('/partner/shipments')).data,
  myInvoices: async (params = {}) => (await api.get('/partner/invoices', { params })).data,
  // Fatura detayı — başlık + kalemler + belge akışı (yalnız kendi carisi)
  myInvoice: async (docnum, doctype) =>
    (await api.get(`/partner/invoices/${encodeURIComponent(docnum)}`, { params: { doctype } })).data,
  // Fatura görüşmesi — iç belge sohbetinin aynı kanalı, dar partner kapısından
  invoiceChat: async (docnum, doctype) =>
    (await api.get(`/partner/invoices/${encodeURIComponent(docnum)}/chat`, { params: { doctype } })).data,
  // Sohbet sayfası — konuşma listesi (genel temsilci görüşmesi + üyesi olduğu belge görüşmeleri)
  chatConversations: async () => (await api.get('/partner/chat/conversations')).data,
  // Görüşme açılabilecek kişiler (kapalı küme) + seçilenlerle DM/grup
  chatPeople: async () => (await api.get('/partner/chat/people')).data,
  createConversation: async (userIds) =>
    (await api.post('/partner/chat/conversations', { user_ids: userIds })).data,
  chatMessages: async (channelId) => (await api.get(`/partner/chat/${channelId}/messages`)).data,
  sendChatMessage: async (channelId, body) =>
    (await api.post(`/partner/chat/${channelId}/messages`, { body })).data,
  sendInvoiceMessage: async (docnum, doctype, body) =>
    (await api.post(`/partner/invoices/${encodeURIComponent(docnum)}/chat/messages`, { body }, { params: { doctype } })).data,
  // Çalışma alanı — şirket yöneticisinin kendi kullanıcı yönetimi (partner_is_admin)
  companyUsers: async () => (await api.get('/partner/users')).data,
  createCompanyUser: async (payload) => (await api.post('/partner/users', payload)).data,
  updateCompanyUser: async (userId, flags) => (await api.put(`/partner/users/${userId}`, flags)).data,
  removeCompanyUser: async (userId) => (await api.delete(`/partner/users/${userId}`)).data,
  resetCompanyUserPassword: async (userId, newPassword) =>
    (await api.put(`/partner/users/${userId}/password`, { new_password: newPassword })).data,
}
